import * as VanillaSharing from 'vanilla-sharing';
import meta from '../data/meta.json';

let _optionsStore = null;
let _hasButtons = false;

const createOptions = (options = {}) => {
    const {
        url = meta.url,
        title = meta.title,
        description = meta.description,
        image = 'share_main.jpg',
        fbappid: fbAppId = meta.fbappid,
        isVkParse = false
    } = options;

    return {
        url,
        title,
        description,
        image: `${meta.url}${image}`,
        media: `${meta.url}${image}`,
        isVkParse,
        fbAppId
    };
};

export const shareFunc = (social) => {
    if (!_optionsStore) return;
    VanillaSharing[social](_optionsStore);
};

const registerListener = (buttonNodeElement) => {
    const { social } = buttonNodeElement.dataset;

    buttonNodeElement.addEventListener('click', () => {
        shareFunc(social);
    });
};

export const updateShareOptions = (options) => {
    if (!_hasButtons) return;
    _optionsStore = createOptions(options);
};

export const initShareButtons = (options = {}) => {
    const buttons = document.querySelectorAll('.share__item');

    if (buttons.length > 0) {
        _hasButtons = true;
        updateShareOptions(options);

        buttons.forEach((button) => {
            registerListener(button);
        });
    }
};
